/// <reference path="../../global/fn.js" />

const board = {
    mixins: [mixin_viewport],
    data: function () {
        return {
            myModal: null,
            boardData: typeof window.boardData !== 'undefined' ? window.boardData : null,
            selectedBoard: null
        };
    },
    mounted() {
        var myModalEl = document.getElementById("boardModal");
        this.myModal = new bootstrap.Modal(myModalEl, {});

        myModalEl.addEventListener("hidden.bs.modal", (event) => {
            this.removeBoard()
        });

        

        this.$watch(() => this.screen, (newVal, oldVal) => {
                if(newVal==='phone'){
                    if(this.selectedBoard){
                        this.myModal.hide();
                    }
                }
            }
        )
        
        
    },
    methods: {
        setBoard(index) {

            this.selectedBoard = this.boardData[index]

            

            if(this.screen==='phone'){
                api.fn.moveWindowToObj(jQuery(this.$el))

            } else if(this.screen==='table' || this.screen==='desktop') {
                this.myModal.show();
            }
        },
        
        removeBoard(){
            this.selectedBoard = null
        }
    },
};

var boardApp = Vue.createApp(board);
if (document.querySelector("#s-board")) boardApp.mount("#s-board");
